import { Dispatch, ReactElement, SetStateAction } from 'react';

import { IconSvgProps } from '@/lib/v2/components';

import { IOrderByTable } from './Campaigns';

export interface IChildProps {
  children: React.ReactElement;
}

export enum EChannelsID {
  EMAIL = 1,
  SMS = 8,
  EMAIL_TRIGGER = 3,
  EMAIL_ATTACHMENT = 9,
  EMAIL_API = 4,
  SMS_API = 5,
}

export interface ChannelInfo {
  icon: ReactElement<IconSvgProps>;
  route: string;
}

export interface IActionsFooterItem {
  id: string;
  label: string;
  value: string;
  icon: JSX.Element;
}

export interface ICampaignActions {
  actionId: number;
  name: string;
  channel: number;
  status: 1 | 0;
  creationDate: string;
  exeDate: string;
  audience: number;
}

export interface ITableCampaignActions {
  action: ICampaignActions;
}

export interface ICampaignsActionsResponse {
  statusOK?: boolean;
  actions?: ITableCampaignActions[];
  total?: number;
  partial?: number;
}

export interface ICampaignActionsListPayload {
  campaignId: number;
  page: number;
  limit: number;
  search?: string;
  state?: number[];
  channel?: number[];
  startDate?: Date;
  endDate?: Date;
  sortField?: string;
  sortOrder?: string;
}

export interface ITotalActions {
  total: number;
  partial: number;
}

export interface IFilterByTable {
  search?: string;
  state?: number[];
  channel?: number[];
  startDate?: Date;
  endDate?: Date;
}

export interface IMutationContext {
  changeTablePage: ({ pageSize, pageIndex }: { pageSize: number; pageIndex: number }) => void;
  resetPagination: () => void;
  setFilterBy: Dispatch<SetStateAction<IFilterByTable>>;
  setClearFilterBy: Dispatch<SetStateAction<boolean>>;
  setOrderBy: (orderBy: IOrderByTable) => void;
}
export interface IStateContext {
  pageSize: number;
  pageIndex: number;
  totalPages: number;
  gotoPageIndex: number;
  filterBy: IFilterByTable;
  clearFilterBy: boolean;
  orderBy: IOrderByTable;
}

export interface IDuplicateCampaignActions {
  actionId: number;
  name: string;
}

export interface IDuplicateCampaignActionsResponse {
  actionIdDuplicate: number;
  statusOK: boolean;
}

export type TActionID = number;

export interface IEditActionPayload {
  campaignElementId: number;
  name: string;
}

export interface IEditActionResponse {
  statusOK: boolean;
}

export interface IFormMoveAction {
  campaigns: string;
}
